import * as Scrivito from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"

export const BuildingReferencesOverviewPageObjClass = Scrivito.provideObjClass(
  "BuildingReferencesOverviewPage",
  {
    attributes: {
      ...defaultPageAttributes,
      childOrder: "referencelist"
    },
    onlyChildren: ["BuildingReference"],
    extractTextAttributes: ["body"]
  }
)

export type BuildingReferencesOverviewPageObj = InstanceType<
  typeof BuildingReferencesOverviewPageObjClass
>
